module.exports = __webpack_public_path__ + "assets/img/chain_file.75ba58f1.jpg";